import React, { useEffect, useState } from "react";
import "./Contacts.css";
import Conect from "../../services/api/Conect";

const Contacts = () => {
  const [clients, setClients] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingClient, setEditingClient] = useState(null);
  const [filter, setFilter] = useState("");
  const [newClient, setNewClient] = useState({
    name: "",
    nick_name: "",
    email: "",
    phone: "",
    phone_whatss: false,
    phone_1: "",
    cpf: "",
  });

  useEffect(() => {
    fetchCostumers();
  }, []);

  const fetchCostumers = async () => {
    const token = localStorage.getItem("fptoken");

    try {
      const response = await Conect.get(`/listallcostumers${token}`);
      if (!response.data.erro) {
        setClients(response.data.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewClient({
      ...newClient,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleAddClient = async () => {
    const token = localStorage.getItem("fptoken");
    try {
      let response;
      if (editingClient) {
        response = await Conect.put(`/editcostumer${editingClient.id}`, newClient);
      } else {
        response = await Conect.post(`/createcostumer${token}`, newClient);
      }

      if (!response.data.erro) {
        fetchCostumers();
        setNewClient({
          name: "",
          phone: "",
          phone_whatss: false,
          phone_1: "",
        });
        setEditingClient(null);
        setIsModalOpen(false);
      }

    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleEditClient = (client) => {
    setNewClient(client);
    setEditingClient(client);
    setIsModalOpen(true);
  };

  const filteredClients = clients.filter((c) =>
    [c.name, c.phone, c.phone_1].some((field) =>
      field?.toLowerCase().includes(filter.toLowerCase())
    )
  );

  return (
    <div className="con-container">
      <div className="con-header">
        <h1 className="con-title">Contatos</h1>
        <input
          type="text"
          className="con-filter"
          placeholder="Buscar por nome ou telefone"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
        <button className="con-add-btn" onClick={() => setIsModalOpen(true)}>
          + Novo Contato
        </button>
      </div>
      <div className="con-table-container">
        {/* 🔹 Lista em formato de tabela */}
        <table className="con-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Telefone</th>
              <th>WhatsApp</th>
              <th>Telefone 2</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {filteredClients.map((client, index) => (
              <tr key={index}>
                <td>{client.name}</td>
                <td>{client.phone}</td>
                <td>{client.phone_whatss ? "✅" : "❌"}</td>
                <td>{client.phone_1 || "-"}</td>
                <td>
                  <button className="con-edit-btn" onClick={() => handleEditClient(client)}>
                    ✏️
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 🔹 Modal */}
      {isModalOpen && (
        <div className="con-modal-overlay">
          <div className="con-modal">
            <h2>{editingClient ? "Editar Contato" : "Novo Contato"}</h2>
            <div className="con-form">
              <input name="name" value={newClient.name} onChange={handleChange} placeholder="Nome completo" />
              <input name="phone" value={newClient.phone} onChange={handleChange} placeholder="Telefone" />
              <label className="con-checkbox">
                <input type="checkbox" name="phone_whatss" checked={newClient.phone_whatss} onChange={handleChange} />
                WhatsApp?
              </label>
              <input name="phone_1" value={newClient.phone_1} onChange={handleChange} placeholder="Telefone alternativo" />
            </div>
            <div className="con-modal-actions">
              <button onClick={() => {
                setIsModalOpen(false); setNewClient({
                  name: "",
                  phone: "",
                  phone_whatss: false,
                  phone_1: "",
                }); setEditingClient(null);
              }}>
                Cancelar
              </button>
              <button onClick={handleAddClient} className="con-save-btn">
                Salvar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contacts;
